<div class="dialog">
  <div class="dialog-top">
    <h4 class="dialog-title short-text"> {{variables.newCatalog}} </h4>
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" class="close-button"
      mat-dialog-close>
      <circle opacity="0.05" cx="20" cy="20" r="20" fill="#0080FF" />
      <path opacity="0.8"
        d="M20.9161 19.9999L24.8099 23.8939C25.0634 24.1472 25.0634 24.5567 24.8099 24.81C24.5567 25.0633 24.1471 25.0633 23.8939 24.81L19.9999 20.916L16.1061 24.81C15.8527 25.0633 15.4433 25.0633 15.1901 24.81C14.9366 24.5567 14.9366 24.1472 15.1901 23.8939L19.0839 19.9999L15.1901 16.1059C14.9366 15.8526 14.9366 15.4431 15.1901 15.1898C15.3163 15.0635 15.4822 15 15.6481 15C15.8139 15 15.9798 15.0635 16.1061 15.1898L19.9999 19.0838L23.8939 15.1898C24.0202 15.0635 24.1861 15 24.3519 15C24.5178 15 24.6836 15.0635 24.8099 15.1898C25.0634 15.4431 25.0634 15.8526 24.8099 16.1059L20.9161 19.9999Z"
        fill="#0080FF" />
      </svg>
    </div>

    <mat-dialog-content>
      <div class="dialog-flex">
        <div class="dialog-box dialog-box-left">
          <form [formGroup]="formGroup1" class="d-flex pt-3">
            <!-- Technology dropdown -->
            <div class="flex-fill">
              <div class="form-group">
                <label class="mb-1 mt-2 input-label mandatory"><span>*</span> {{ variables.technology }}</label>
              <mat-form-field class="form-field" appearance="outline" [ngClass]="{
                'mat-form-field-custom': true,
                'ng-invalid': invalidInput2,
                'mat-form-field-invalid': invalidInput2
              }">
                  <mat-select formControlName="techCtrl" placeholder="{{ variables.insertTechnologyNameMessage }}">
                    @for (item of allTechs; track item) {
                      <mat-option [value]="item.id">
                        {{ item.name }}
                      </mat-option>
                    }
                  </mat-select>
                  @if (formGroup1.get('techCtrl')?.hasError('required')) {
                    <mat-error>
                      Technology Required
                    </mat-error>
                  }
                  @if (invalidInput2) {
                    <mat-hint class="error-hint">{{ errorMessage2 }}</mat-hint>
                  }
                </mat-form-field>
              </div>

              <br>
                <br>

                  <!-- Name input -->
                  <div class="form-group">
                    <label class="mb-1 input-label mandatory"><span>*</span> {{ variables.name }}</label>
              <mat-form-field class="form-field" appearance="outline" [ngClass]="{
                'mat-form-field-custom': true,
                'ng-invalid': invalidInput,
                'mat-form-field-invalid': invalidInput
              }">
                      <input matInput formControlName="catalogNameCtrl" (change)="onChange()">
                      @if (formGroup1.get('catalogNameCtrl')?.hasError('required')) {
                        <mat-error>
                          Name Required
                        </mat-error>
                      }
                      @if (invalidInput) {
                        <mat-hint class="error-hint">{{ errorMessage }}</mat-hint>
                      }
                    </mat-form-field>
                  </div>
                </div>

                <div class="vertical-line"></div>

                <div class="flex-fill">
                  <div class="dialog-box dialog-box-right">
                    <p class="label ps">{{variables.selectTechToImportConfig}}</p>
                    <div class="radio-group-control">
                      @for (item of filteredCatalogs; track item) {
                        <div class="radio-group-control-item">
                          <div
                            class="radio-group-control-item-button"
                            [class.selected]="formGroup1.get('importCtrl')?.value === item.id"
                            role="button"
                            tabindex="0"
                            (click)="resetRadio(item.id)"
                            (keydown.enter)="resetRadio(item.id)"
                            (keydown.space)="resetRadio(item.id)">
                            {{item.name}}
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div>
            <mat-dialog-actions class="button-group">
              <app-button typeBtn="secondary" message="{{variables.cancel}}" mat-dialog-close></app-button>
              @if (importedCatalog === '') {
                <app-button typeBtn="primary" message="{{variables.create}}" (click)="doAction()"></app-button>
              }
              @else { 
                <app-button typeBtn="primary" message="{{variables.clone}}" (click)="doAction()"></app-button>
              }
            </mat-dialog-actions>
          </div>
        </mat-dialog-content>
      </div>